





























































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
import {
  Action,
  Getter,
} from 'vuex-class';
import ImageSelector from '@/components/ImageSelector.vue';

@Component({
  components: {ImageSelector},
})
export default class DlgMemberNew extends Vue {
  public $refs!: {
    form: any,
  };

  @Action('moderator/animals/create') private createAnimal!: any;
  @Action('moderator/animals/read') private readAnimals!: any;
  @Action('moderator/animals/uploadImage') private uploadImage!: any;
  @Getter('common/rules/all') private rules!: any;

  private animal: any = {};
  private galleryImages: any = [null];
  private profileImage: any = null;
  private dialog: boolean = false;
  private loading: boolean = false;
  private valid: boolean = true;

  private async save() {
    if (this.$refs.form.validate()) {
      this.loading = true;

      // Step 1: upload all the images
      this.animal.profileImage = await this.uploadImage(this.profileImage);
      // Step 2: add urls to profileImage and previewImage Array

      // Step 3: save animal

      this.createAnimal(this.animal)
        .then((success: any) => {
          if (success) {
            return this.readAnimals();
          }
          throw new Error();
        })
        .then(() => {
          this.loading = false;
          this.dialog = false;
          this.animal = {};
          this.$refs.form.resetValidation();
        })
        .catch(() => {
          this.loading = false;
        });
    }
  }

  private addGalleryImage(n) {
    if (this.galleryImages.length - 1 === n) {
      this.galleryImages.push(null);
    }
  }
}
